import { Provider } from '@angular/core';

import { ZendeskService } from '../services';
import { ZendeskFacade, ZendeskStore } from '../store';

export function provideZendeskDataAccess(): Provider[] {
  return [ZendeskService, ZendeskStore, ZendeskFacade];
}
